import { Component, Input, Output, EventEmitter, TemplateRef, SimpleChanges } from '@angular/core';
import { DrugRevenue } from '../pharma-page.model';

@Component({
  selector: 'app-drug-revenue-filter',
  templateUrl: './drug-revenue-filter.component.html',
  styleUrls: ['./drug-revenue-filter.component.scss']
})
export class DrugRevenueFilterComponent {
  @Input() loading: boolean;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() panel = {} as any;
  @Input() data: DrugRevenue;
  @Input() facetFilter: any;
  @Input() amountFormatter: TemplateRef<any>;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Output() onUpdateGraph: EventEmitter<any> = new EventEmitter();

  selected_year: string;
  selected_risk_type: string;
  selected_min: number;
  selected_max: number;
  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && this.data && this.facetFilter) {
      if (!this.selected_year || !this.selected_risk_type) {
        if (!this.selected_year && this.data?.default_year) {
          this.selected_year = this.facetFilter.selected_year || this.data.default_year;
        }
        if (!this.selected_risk_type && this.data?.default_risk) {
          this.selected_risk_type = this.facetFilter.selected_risk_type || this.data.default_risk;
        }
      }
      this.changeMinMax();
    }
    console.log(this.data);
  }

  onRevenueChange(obj) {
    let payload = {
      ...this.facetFilter,
      selected_min: obj.min,
      selected_max: obj.max,
      selected_risk_type: this.selected_risk_type,
      selected_year: this.selected_year
    };
    this.onChange.emit(payload);
  }

  onDropdownChange(year) {
    let payload = {
      ...this.facetFilter,
      selected_min: this.selected_min,
      selected_max: this.selected_max,
      selected_risk_type: this.selected_risk_type,
      selected_year: this.selected_year
    };
    this.onUpdateGraph.emit(payload);
  }

  // onRiskTypeChange(riskType) {
  //   let payload = {...this.facetFilter, selected_risk_type: riskType };
  //   this.onChange.emit(payload);
  // }

  changeMinMax() {
    this.selected_min = this.facetFilter.selected_min || this.data.min;
    this.selected_max = this.facetFilter.selected_max || this.data.max;
  }
}
